/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butactive1Inputs */

const de__field_butactive1 = /** @type {(inputs: _Field_Butactive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT aktives Schuljahr`)
};

/**

* @param {_Field_Butactive1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butactive1 = /** @type {((inputs?: _Field_Butactive1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butactive1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butactive1(inputs)
});
export { _field_butactive1 as "_field_butActive" }